//#region src/version.ts
const PACKAGE_VERSION = "2.31.3";
//#endregion
export { PACKAGE_VERSION };

//# sourceMappingURL=version.mjs.map